module.exports = __webpack_public_path__ + "static/7-b069db0d2c1c2a1cc4a50d6cedf99817.jpg";